// Shared visibility rule for conditional questions. A conditional makes its
// question visible only when the parent question's answer matches. Two parent
// shapes are supported:
//   - single-choice / image(single-choice): answer is a string, matched by
//     `requiresValue` (no `requiresLabel`).
//   - combobox: answer is an array of { label, value } rows; visible when a row's
//     `label` === `requiresLabel` AND `value` === `requiresValue`.
export const isConditionalSatisfied = (conditional, answers) => {
  if (!conditional?.dependsOn) return true;
  const parent = answers?.[conditional.dependsOn];
  if (conditional.requiresLabel != null) {
    return Array.isArray(parent) && parent.some(
      (row) => row && row.label === conditional.requiresLabel
                   && row.value === conditional.requiresValue
    );
  }
  return parent === conditional.requiresValue;
};

export const wasQuestionVisible = (question, answers) =>
  isConditionalSatisfied(question?.conditional, answers);
